// Messages for portal/quotes/RequestQuoteModal (auto-merged by lib/i18n.ts).
export const en = {
  'portal.request_quote.title': 'Request a quote',
  'portal.request_quote.cancel': 'Cancel',
  'portal.request_quote.send': 'Send request',
  'portal.request_quote.intro':
    "Tell us the lane and cargo and we'll get back to you with pricing.",
  'portal.request_quote.origin': 'Origin',
  'portal.request_quote.origin_placeholder': 'e.g. Shanghai',
  'portal.request_quote.destination': 'Destination',
  'portal.request_quote.destination_placeholder': 'e.g. Chicago',
  'portal.request_quote.mode': 'Shipping mode',
  'portal.request_quote.mode.ship': 'Ocean',
  'portal.request_quote.mode.air': 'Air',
  'portal.request_quote.mode.truck': 'Truck',
  'portal.request_quote.mode.train': 'Rail',
  'portal.request_quote.load_type': 'Load type',
  'portal.request_quote.incoterm': 'Incoterm (optional)',
  'portal.request_quote.incoterm_none': 'Not sure yet',
  'portal.request_quote.cargo_ready_date': 'Cargo ready date (optional)',
  'portal.request_quote.commodity': 'Commodity (optional)',
  'portal.request_quote.commodity_placeholder': 'e.g. Electronics',
  'portal.request_quote.details': 'Shipment details',
  'portal.request_quote.details_placeholder': 'Weight, volume, pieces, special handling…',
}

export const zhTW = {
  'portal.request_quote.title': '索取報價',
  'portal.request_quote.cancel': '取消',
  'portal.request_quote.send': '送出申請',
  'portal.request_quote.intro': '告訴我們航線與貨物，我們會回覆您報價。',
  'portal.request_quote.origin': '起運地',
  'portal.request_quote.origin_placeholder': '例如：上海',
  'portal.request_quote.destination': '目的地',
  'portal.request_quote.destination_placeholder': '例如：芝加哥',
  'portal.request_quote.mode': '運輸模式',
  'portal.request_quote.mode.ship': '海運',
  'portal.request_quote.mode.air': '空運',
  'portal.request_quote.mode.truck': '陸運',
  'portal.request_quote.mode.train': '鐵路',
  'portal.request_quote.load_type': '裝載類型',
  'portal.request_quote.incoterm': '貿易條件（選填）',
  'portal.request_quote.incoterm_none': '尚未確定',
  'portal.request_quote.cargo_ready_date': '貨物備妥日期（選填）',
  'portal.request_quote.commodity': '商品（選填）',
  'portal.request_quote.commodity_placeholder': '例如：電子產品',
  'portal.request_quote.details': '貨件詳情',
  'portal.request_quote.details_placeholder': '重量、體積、件數、特殊處理…',
}
